import { FC } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS, PAGE_URLS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import {
  clearProjectDetails,
  clearStartChildProgramNavigation,
} from "../../../../redux/slices/project/projectSlice";
import { searchProjectsHeaderSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { ProjectSearchHeaderWrapper } from "./ProjectSearchHeader.style";

const pageId = "project-search";

export const ProjectSearchHeader: FC = () => {
  const navigate = useNavigate();
  const { fetchLabel, pageTitle } = useSiteCore();
  const dispatch = useDispatch();

  const handleNavigate = () => {
    dispatch(clearStartChildProgramNavigation()); // Clear Child Program Navigation state
    dispatch(clearProjectDetails()); // Clear Project Details
    navigate(PAGE_URLS.CREATE_PROJECT, {
      state: { from: PAGE_URLS.SEARCH_PROJECT },
    });
  };
  return (
    <ProjectSearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>

        <PermissionWrapper permission={MODULE_PERMISSIONS.PROJECT_CREATE}>
          <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
            <MuiButtonPrimary
              onClick={handleNavigate}
              className="header-right-button"
              id={`${pageId}-newProject`}
              data-testid="new-project"
            >
              {fetchLabel(
                searchProjectsHeaderSiteCoreKeys.header,
                searchProjectsHeaderSiteCoreKeys.createNewProjectButton,
              )}
            </MuiButtonPrimary>
          </MuiGrid>
        </PermissionWrapper>
      </MuiGrid>
    </ProjectSearchHeaderWrapper>
  );
};
